import environment from '../scripts/environment';

export const normalizeStoreTypeSaleMarketValue = (value) =>
    String(value)
        .split('|')
        .map(v => v.trim())
        .filter(v => v.length)
        .sort()
        .join('|');

export const treatStoreTypeSaleMarketValue = (value) => {
    const data = environment.get('CONFIG.FILTERS.TYPE_SALES_MARKET');
    const normalized = normalizeStoreTypeSaleMarketValue(value);
    const match = data.find(v => normalizeStoreTypeSaleMarketValue(v.value) === normalized);
    return match ? match.text : undefined;
};



// WEBPACK FOOTER //
// ./src/models/StoreTypeSaleMarket.js